// extracted by mini-css-extract-plugin
module.exports = {"MarketTitle":"Navbar__MarketTitle__3LF9"};